import React from "react";
import { Sling as Hamburger } from "hamburger-react";
import { useScroll } from "../../context/UseContextScroll.js";
import ArrowIcon from "../../img/ArrowIcon.jsx";

import {
  ContainerIdiom,
  ContainerIdiomView,
  Country,
  CountryModal,
  ContainerText,
  Button,
  ContainerButton,
  ContainerMenu,
  ContainerIdiomDesktop,
  ButtonIdiomDeskt,
  ButtonBurguer,
  ContainerNavBarFixed,
  TextProde,
} from "./style";
import UseNavBara from "./useNav";

const NavBar = ({ openMenu, setOpenMenu }) => {
  const { scroll } = useScroll();

  const {
    englishLanguage,
    portugueseLanguage,
    spanishLanguage,
    uk,
    esp,
    bra,
    modalFlag,
    setModalFlag,
    t,
  } = UseNavBara();

  return (
    <div className="demo_wrap">
      <ContainerNavBarFixed scroll={scroll}>
        <TextProde>PROODE MUNDIAL</TextProde>
        <ContainerMenu>
          <a href="#feature">{t("features.features")}</a>
          <a company="true" href="#business">
            {t("business.business")}
          </a>
          <a href="#contact">{t("contact.contact")}</a>
        </ContainerMenu>
        <ContainerIdiomDesktop>
          <ButtonIdiomDeskt onClick={englishLanguage} uk={uk}>
            ENG
          </ButtonIdiomDeskt>
          <ButtonIdiomDeskt onClick={spanishLanguage} esp={esp}>
            ESP
          </ButtonIdiomDeskt>
          <ButtonIdiomDeskt onClick={portugueseLanguage} bra={bra}>
            POR
          </ButtonIdiomDeskt>
        </ContainerIdiomDesktop>
      </ContainerNavBarFixed>
      <ButtonBurguer onClick={() => setOpenMenu(!openMenu)}>
        <Hamburger
          toggled={openMenu}
          toggle={setOpenMenu}
          color="#FFF"
          size={20}
        />
      </ButtonBurguer>
      <ContainerIdiom onClick={() => setModalFlag(!modalFlag)}>
        <Country>{bra ? "POR" : uk ? "ENG" : "ESP"}</Country>
        <ArrowIcon modalFlag={modalFlag} />

        <ContainerIdiomView modalFlag={modalFlag}>
          <CountryModal onClick={spanishLanguage}>ESP</CountryModal>
          <CountryModal onClick={portugueseLanguage}>POR</CountryModal>
          <CountryModal onClick={englishLanguage}>ENG</CountryModal>
        </ContainerIdiomView>
      </ContainerIdiom>

      <ContainerText>
        <h3>PROODE MUNDIAL</h3>

        <h1>{t("liveCup.liveCup")}</h1>
        <p>{t("subLiveCup.subLiveCup")}</p>
        <ContainerButton>
          <Button href="#contact">{t("contactUs.contactUs")}</Button>

          {/* <Button>Probá el demo</Button> */}
        </ContainerButton>
      </ContainerText>
    </div>
  );
};

export default NavBar;
